<template>
  <div :id="id" :class="className" :style="{height:height,width:width}"/>
</template>

<script>
  import echarts from 'echarts'

  export default {
    name: 'line-charts',
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      id: {
        type: String,
        default: 'chart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '235px'
      },
      chartData: {
        type:Object,
        required:true
      },
      chartTitle:{
        type:String,
        required:true
      },
    },
    data() {
      return {
        chart: null
      }
    },
    computed:{
      isCollapsed(){
        return this.$store.state.app.sidebar.clapse
      }
    },
    watch:{
      isCollapsed(){
        this.resizeCharts()
      }
    },
    mounted() {
      let _that = this
      this.initLineCharts()
      this.resizeCharts()
      window.addEventListener('resize', () => {
        this.resizeCharts()
      })
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      window.removeEventListener('resize', () => {
        this.resizeCharts()
      })
      this.chart.dispose() // 销毁
      this.chart = null
    },
    methods: {
      /**
       * 重置图表
       * */
      resizeCharts(){
        setTimeout( () => {
          if(this.chart){
            this.chart.resize()
          }
        }, 350)
      },
      /**
       * 初始化图表
       */
      initLineCharts() {
        this.chart = echarts.init(document.getElementById(this.id))
        let chartData = this.chartData
        let legendData = []
        let seriesData = []

        for (let key in chartData){
          legendData.push(key)
          seriesData.push({
            name: key,
            value: chartData[key]
          })
        }
        this.chart.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}%'
          },
          legend: {
            left: '0',
            top: '10',
            orient: 'vertical',
            data: legendData
          },
          series: [
            {
              name: this.chartTitle,
              type: 'pie',
              roseType: 'radius',
              align: 'left',
              radius: [15, 95],
              data: seriesData,
              animationEasing: 'cubicInOut',
              animationDuration: 2600
            }
          ]
        })
      }
    },
  }
</script>

<style lang="">

</style>
